$(function () {
	$('a[href*=\\#]:not([href=\\#])').on('click', function () {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var $target = $(this.hash);
			$target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');
			if ($target.length) {
				var targetOffset = $target.offset().top;
				$('html,body').animate({ scrollTop: targetOffset }, 1000);
				return false;
			}
		}
	});

	var pcflag = (window.innerWidth > 896);
	var spflag = !pcflag;
	var resizing = false;
	var resizeTimeout;

	function handleResize() {
		if (window.innerWidth < 897) {
			if (pcflag && !resizing) {
				resizing = true;
				pcflag = false;
				spflag = true;
				setTimeout(function () {
					window.location.reload();
				}, 300);
			}
		} else {
			if (spflag && !resizing) {
				resizing = true;
				pcflag = true;
				spflag = false;
				setTimeout(function () {
					window.location.reload();
				}, 300);
			}
		}
	}

	$(window).on('resize', function () {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(function () {
			resizing = false;
			handleResize();
		}, 100);
	});
});

$(window).on('load', function () {
	var localLink = window.location + '';
	if (localLink.indexOf("#") != -1 && localLink.slice(-1) != '#') {
		localLink = localLink.slice(localLink.indexOf("#") + 1);
		if ($('#' + localLink).length) {
			setTimeout(function () {
				$('html,body').animate({ scrollTop: $('#' + localLink).offset().top }, 500);
			}, 100);
		}
	}
});